import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";
import { CUSTOMER_SEARCH_RESOURCE } from "./use-customer-search.query";

export const CUSTOMER_FULL_SYNC_OPERATION = "full-sync" as const;
export const CUSTOMER_FULL_SYNC_API_PATH = `/v1/${CUSTOMER_SEARCH_RESOURCE}/${CUSTOMER_FULL_SYNC_OPERATION}` as const;

export type CustomerFullSyncResponse =
  paths[typeof CUSTOMER_FULL_SYNC_API_PATH]["post"]["responses"][202]["content"]["application/json"];
export type CustomerFullSyncBody =
  paths[typeof CUSTOMER_FULL_SYNC_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useCustomerFullSyncMutation = () => {
  return useMutation<CustomerFullSyncResponse, Error, CustomerFullSyncBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<CustomerFullSyncResponse>(CUSTOMER_FULL_SYNC_API_PATH, body);
      return response.data;
    },
  });
};
